module.exports = __webpack_public_path__ + "img/info-03.be701bbc.jpg";